import { Injectable } from '@angular/core';
import { UserType } from '../enums/user-type';
import { AssignmentDTO } from '../models/Assignment';
import { UserAssignment } from '../models/user-assignment';

@Injectable({
  providedIn: 'root'
})
export class AssignmentGroupSharedDataService {
  foundUser:any;

  constructor() { }

    
  updateUserToAssignmentTypeArray(userList: string[] , users: string[] | null, assignmentGroupList: any,  assignedAssignmentGroupsAndUsersList: any): AssignmentDTO[] | undefined {
    const assignmentDTOs: AssignmentDTO[] = [];
    if (!users) {
      return undefined;
    }
    users.forEach((user) => {
    if (userList.some((obj:any) => obj.value === user)) {
        assignmentDTOs.push({
          assignmentType: 1,
          assignedUserName: user,
          assignmentId: undefined,
          isActive: false
        });
      } else {
        let assignmentGroup;      
        if (assignmentGroupList && assignmentGroupList.length > 0) {
          assignmentGroup = this.getAssignmentGroup(assignmentGroupList.filter((obj: any) => obj.name === user));
        }  
        if (!assignmentGroup && assignedAssignmentGroupsAndUsersList && assignedAssignmentGroupsAndUsersList.length > 0) {
          assignmentGroup = this.getAssignmentGroup(assignedAssignmentGroupsAndUsersList.filter((obj: any) => obj.name === user));
        }        
        assignmentDTOs.push({
          assignmentType: 0,
          assignedUserName: user,
          assignmentId: assignmentGroup?.id,
          isActive: assignmentGroup?.isActive ?? false
        });
      }
    });    
    return assignmentDTOs;
  }

updateUserToAssignmentTypeArrayForSession(userList: any|null , usersdataFromCourse: any|null): AssignmentDTO[] | undefined {
    const assignmentDTOs: AssignmentDTO[] = [];
    if (!usersdataFromCourse || !userList) {
      return undefined;
    }
  usersdataFromCourse.forEach((userInfo:any) => {
    if(userList.some((obj:any)=> obj=== userInfo.name && (userInfo.assignmentId===null || userInfo.assignmentId == undefined )))
      {
        assignmentDTOs.push({
          assignmentType: 1,
          assignedUserName: userInfo.name,
          assignmentId: userInfo.assignmentId === undefined ? null : userInfo.assignmentId,
          isActive: false
      });
    }
    else
    {
        if(userList.some((obj:any)=>obj===userInfo.name && userInfo.assignmentId!==null))
        {
          assignmentDTOs.push({
            assignmentType: 0,
            assignedUserName: userInfo.name,
            assignmentId: userInfo.assignmentId,
            isActive: userInfo?.isActive
        });
        }
    }}); 
    return assignmentDTOs;
  }


  updateUserToAssignmentType(userList: string[], user: string | null, assignmentGroupList: any, assignedAssignmentGroupsAndUsersList: any): AssignmentDTO | undefined {
    if (!user) {
      return undefined;
    }
    const foundUser = userList.find((obj:any) => obj.value === user);  
    if (foundUser) {
      return {
        assignmentType: 1,
        assignedUserName: user,
        assignmentId: undefined,
        isActive: false
      };
    } else {
      let assignmentGroup = this.getAssignmentGroup(assignmentGroupList.filter((obj:any) => obj.name === user));
      if(typeof assignmentGroup === 'undefined') {
        assignmentGroup = this.getAssignmentGroup(assignedAssignmentGroupsAndUsersList.filter((obj:any) => obj.name === user))
      }
      return {
        assignmentType: 0,
        assignedUserName: user,
        assignmentId: assignmentGroup?.id,
        isActive : assignmentGroup?.isActive
      };
    }
  }  
  getAssignmentGroup(assignmentGroup: any): any {
    if (Array.isArray(assignmentGroup)) {
      return assignmentGroup[0];
    } else {
      return assignmentGroup;
    }
  } 

  sortAssignmentGroupListByName(list: any[]) {
    return list.sort((a, b) => {
      const nameA = a.name.toUpperCase();
      const nameB = b.name.toUpperCase();
      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }
      return 0;
    });
  }

  findInactiveObjects(object: any): AssignmentDTO[] | undefined {
    const inactiveObjects: AssignmentDTO[] = [];

    if (object) {
      let inactiveAssignedAdmins = object.assignedAdmins?.filter((assignedAdmin:any) => !assignedAdmin.isActive && assignedAdmin.assignmentType == 0);
      if (inactiveAssignedAdmins) {
        inactiveAssignedAdmins.forEach((assignedAdmin:any)=>{
          const adminAssignment = {...assignedAdmin, source: 'Assigned Admins'};
          inactiveObjects.push(adminAssignment);
        })
      }

      const inactiveCollaborators = object.collaborators?.filter((collaborator:any) => !collaborator.isActive && collaborator.assignmentType == 0);
      if(inactiveCollaborators){
        inactiveCollaborators.forEach((collaborator:any) => {
          const collaboratorAssignment = {...collaborator, source: 'Collaborators'};
          inactiveObjects.push(collaboratorAssignment);
        });
      }

      const inactiveAssignedQAs = object.assignedQAs?.filter((qa:any) => !qa.isActive && qa.assignmentType == 0);
      if(inactiveAssignedQAs){
        inactiveAssignedQAs.forEach((qa:any) => {
          const qaAssignment = {...qa, source: 'Assigned QAs'};
          inactiveObjects.push(qaAssignment);
        });
      }

      const inactiveAssignedDocControls = object.assignedDocControl?.filter((docControl:any) => !docControl.isActive && docControl.assignmentType == 0);
      if(inactiveAssignedDocControls){
        inactiveAssignedDocControls.forEach((docControl:any) => {
          const docControlAssignment = {...docControl, source: 'Assigned Doc Control'};
          inactiveObjects.push(docControlAssignment);
        });
      }

      if (inactiveObjects.length > 0) {
        return inactiveObjects;
      }
    }

    return undefined;
  }

  //Method to validate for inactive users or groups in the selected slider user controls
  findInactiveObjectsInValidatedList(object: any, validatedUsersList: UserAssignment[], userList: any[]): AssignmentDTO[] | undefined {
    const inactiveObjects: AssignmentDTO[] = [];

    if (object && validatedUsersList) {
      validatedUsersList.forEach((userAssignment) => {
        if (userAssignment.userType === UserType.Collaborators) {
          const collaboratorNames = object.collaborators?.map((collaborator: any) => collaborator.assignedUserName);
          if (collaboratorNames != null && collaboratorNames != undefined) {
            const terminatedCollaborators = collaboratorNames.filter((name: any) =>
              !userList.some((user) => user.name === name)
            );
            const inactiveCollaborators = userAssignment.userAssignmentList.filter((user: AssignmentDTO) =>
              collaboratorNames.includes(user.assignedUserName) && !user.isActive
            );
            // Combine both lists (inactive users and terminated users)
          const inactiveAndTerminatedUsers = [
            ...inactiveCollaborators,
            ...terminatedCollaborators.map((name: any) => ({ assignedUserName: name, isActive: false })) // Create inactive user objects for missing reviewers
          ];
          inactiveAndTerminatedUsers.forEach((collaborator) => {
              const collaboratorAssignment = { ...collaborator, source: 'Collaborators' };
              inactiveObjects.push(collaboratorAssignment);
            });
          }
        }
        if (userAssignment.userType === UserType.AssignedAdmins) {
          const assignedAdminsNames = object.assignedAdmins.map((assignedAdmin: any) => assignedAdmin.assignedUserName);
          const terminatedAssignedAdmins = assignedAdminsNames.filter((name: any) =>
            !userList.some((user) => user.name === name)
          );
          const inactiveAssignedAdmins = userAssignment.userAssignmentList.filter((user: AssignmentDTO) =>
            assignedAdminsNames.includes(user.assignedUserName) && !user.isActive
          );
          // Combine both lists (inactive users and terminated users)
          const inactiveAndTerminatedUsers = [
            ...inactiveAssignedAdmins,
            ...terminatedAssignedAdmins.map((name: any) => ({ assignedUserName: name, isActive: false })) // Create inactive user objects for missing reviewers
          ];
          inactiveAndTerminatedUsers.forEach((assignedAdmin) => {
            const assignedAdminsAssignment = { ...assignedAdmin, source: 'Assigned Admins' };
            inactiveObjects.push(assignedAdminsAssignment);
          });
        }

        if (userAssignment.userType === UserType.AssignedQAs) {
          const assignedQAsNames = object.assignedQAs?.map((assignedQA: any) => assignedQA.assignedUserName);
          if (assignedQAsNames != null && assignedQAsNames != undefined) {
            const terminatedAssignedQAs = assignedQAsNames.filter((name: any) =>
              !userList.some((user) => user.name === name)
            );
            const inactiveAssignedQAs = userAssignment.userAssignmentList.filter((user: AssignmentDTO) =>
              assignedQAsNames.includes(user.assignedUserName) && !user.isActive
            );
            // Combine both lists (inactive users and terminated users)
          const inactiveAndTerminatedUsers = [
            ...inactiveAssignedQAs,
            ...terminatedAssignedQAs.map((name: any) => ({ assignedUserName: name, isActive: false })) // Create inactive user objects for missing reviewers
          ];
          inactiveAndTerminatedUsers.forEach((assignedQA) => {
              const assignedQAAssignment = { ...assignedQA, source: 'Assigned QAs' };
              inactiveObjects.push(assignedQAAssignment);
            });
          }
        }

        if (userAssignment.userType === UserType.AssignedDocControls) {
          const assignedDocControlsNames = object.assignedDocControl.map((assignedDocControl: any) => assignedDocControl.assignedUserName);
          const terminatedDocControls = assignedDocControlsNames.filter((name: any) =>
            !userList.some((user) => user.name === name)
          );
          const inactiveAssignedDocControls = userAssignment.userAssignmentList.filter((user: AssignmentDTO) =>
            assignedDocControlsNames.includes(user.assignedUserName) && !user.isActive
          );
          // Combine both lists (inactive users and terminated users)
          const inactiveAndTerminatedUsers = [
            ...inactiveAssignedDocControls,
            ...terminatedDocControls.map((name: any) => ({ assignedUserName: name, isActive: false })) // Create inactive user objects for missing reviewers
          ];
          inactiveAndTerminatedUsers.forEach((assignedDocControl) => {
            const docControlAssignment = { ...assignedDocControl, source: 'Assigned Doc Controls' };
            inactiveObjects.push(docControlAssignment);
          });
        }

        if (userAssignment.userType === UserType.Reviewers) {
          const reviewersNames = object.reviewers.map((reviewer: any) => reviewer);
          const terminatedReviewers = reviewersNames.filter((name: any) =>
            !userList.some((user) => user.name === name)
          );
          const inactiveReviewers = userAssignment.userAssignmentList.filter((user: AssignmentDTO) =>
            reviewersNames.includes(user.assignedUserName) && !user.isActive
          );
          // Combine both lists (inactive users and terminated users)
          const inactiveAndTerminatedUsers = [
            ...inactiveReviewers,
            ...terminatedReviewers.map((name: any) => ({ assignedUserName: name, isActive: false })) // Create inactive user objects for missing reviewers
          ];
          inactiveAndTerminatedUsers.forEach((reviewer) => {
            const reviewerAssignment = { ...reviewer, source: 'Reviewers' };
            inactiveObjects.push(reviewerAssignment);
          });
        }

        if (userAssignment.userType === UserType.Approvers) {
          const approversNames = object.approvers.map((approver: any) => approver);
          const terminatedApprovers = approversNames.filter((name: any) =>
            !userList.some((user) => user.name === name)
          );
          const inactiveApprovers = userAssignment.userAssignmentList.filter((user: AssignmentDTO) =>
            approversNames.includes(user.assignedUserName) && !user.isActive
          );
          // Combine both lists (inactive users and terminated users)
          const inactiveAndTerminatedUsers = [
            ...inactiveApprovers,
            ...terminatedApprovers.map((name: any) => ({ assignedUserName: name, isActive: false })) // Create inactive user objects for missing reviewers
          ];
          inactiveAndTerminatedUsers.forEach((approver) => {
            const approverAssignment = { ...approver, source: 'Approvers' };
            inactiveObjects.push(approverAssignment);
          });
        }
        // To generate Confirmation message, if any inactive users present in Internal Client Contacts while editing
        if (userAssignment.userType === UserType.DocumentInternalClientContacts) {
          const internalClientContactsNames = object.internalClientContacts?.map((internalClientContact: any) => internalClientContact.assignedUserName);
          if (internalClientContactsNames != null && internalClientContactsNames != undefined) {
            const terminatedInternalClientContacts = internalClientContactsNames.filter((name: any) =>
              !userList.some((user) => user.name === name)
            );
            const inactiveInternalClientContacts = userAssignment.userAssignmentList.filter((user: AssignmentDTO) =>
              internalClientContactsNames.includes(user.assignedUserName) && !user.isActive
            );
            // Combine both lists (inactive users and terminated users)
          const inactiveAndTerminatedUsers = [
            ...inactiveInternalClientContacts,
            ...terminatedInternalClientContacts.map((name: any) => ({ assignedUserName: name, isActive: false })) // Create inactive user objects for missing reviewers
          ];
          inactiveAndTerminatedUsers.forEach((internalClient) => {
              const internalClientContactsAssignment = { ...internalClient, source: 'Internal Client Contacts' };
              inactiveObjects.push(internalClientContactsAssignment);
            });
          }
        }

        if (userAssignment.userType === UserType.PeriodicReviewers) {
          const periodicReviewersNames = object.periodicReviewers?.map((periodicReviewer: any) => periodicReviewer.assignedUserName);
          if (periodicReviewersNames != null && periodicReviewersNames != undefined) {
            const terminatedPeriodicReviewers = periodicReviewersNames.filter((name: any) =>
              !userList.some((user) => user.name === name)
            );
            const inactivePeriodicReviewers = userAssignment.userAssignmentList.filter((user: AssignmentDTO) =>
              periodicReviewersNames.includes(user.assignedUserName) && !user.isActive
            );
            // Combine both lists (inactive users and terminated users)
          const inactiveAndTerminatedUsers = [
            ...inactivePeriodicReviewers,
            ...terminatedPeriodicReviewers.map((name: any) => ({ assignedUserName: name, isActive: false })) // Create inactive user objects for missing reviewers
          ];
          inactiveAndTerminatedUsers.forEach((periodicReviewer) => {
              const periodicReviewerAssignment = { ...periodicReviewer, source: 'Periodic Reviewers' };
              inactiveObjects.push(periodicReviewerAssignment);
            });
          }
        }

        if (userAssignment.userType === UserType.Author) {
          const authorName = object.author;
          // Check if the authorName is not present in userList
          let terminatedAuthor = null;
          if (!userList.find((user) => user.name === authorName)) {
            // Add authorName to terminatedAuthors if it's not found in userList
            terminatedAuthor = authorName;
          }
          const inactiveAuthor = userAssignment.userAssignmentList.find((user: AssignmentDTO) =>
            !user.isActive && user.assignedUserName === authorName
          );

          // Combine both lists (inactive users and terminated users)
          let inactiveAndTerminatedUsers = [];
          if (inactiveAuthor) {
            inactiveAndTerminatedUsers.push(inactiveAuthor);
          }
          else if (terminatedAuthor != null) {
            inactiveAndTerminatedUsers.push(terminatedAuthor);
          }

          inactiveAndTerminatedUsers.forEach((user) => {
              const userAssignmentWithSource = { ...user, source: 'Author' };
              inactiveObjects.push(userAssignmentWithSource);
            });
        }

        if (userAssignment.userType === UserType.AssignedUser) {
          const usersNames = object.value.users.map((user: any) => user);
          const terminatedAssignedUsers = usersNames.filter((name: any) =>
            !userList.some((user) => user.name === name)
          );
          const inactiveUsers = userAssignment.userAssignmentList.filter((user: AssignmentDTO) =>
            usersNames.includes(user.assignedUserName) && !user.isActive
          );
          // Combine both lists (inactive users and terminated users)
          const inactiveAndTerminatedUsers = [
            ...inactiveUsers,
            ...terminatedAssignedUsers.map((name: any) => ({ assignedUserName: name, isActive: false })) // Create inactive user objects for missing reviewers
          ];
          inactiveAndTerminatedUsers.forEach((user) => {
            const userAssignment = { ...user, source: 'Users' };
            inactiveObjects.push(userAssignment);
          });
        }

        if (userAssignment.userType === UserType.CCImplementationOwner) {
          const usersNames = object.implementationOwners.map((user: any) => user.assignedUserName);
          const terminatedUsers = usersNames.filter((name: any) =>
            !userList.some((user) => user.name === name)
          );
          const inactiveUsers = userAssignment.userAssignmentList.filter((user: AssignmentDTO) =>
            usersNames.includes(user.assignedUserName) && !user.isActive
          );
          // Combine both lists (inactive users and terminated users)
          const inactiveAndTerminatedUsers = [
            ...inactiveUsers,
            ...terminatedUsers.map((name: any) => ({ assignedUserName: name, isActive: false })) // Create inactive user objects for missing reviewers
          ];
          inactiveAndTerminatedUsers.forEach((user) => {
            const userAssignment = { ...user, source: 'Change Control Implementation Owners' };
            inactiveObjects.push(userAssignment);
          });
        }
        if (userAssignment.userType === UserType.CCCollaborator) {

          const collaboratorsUserNames = object.collaborators.map((user: any) => user.assignedUserName);
          const terminatedUsers = collaboratorsUserNames.filter((name: any) =>
            !userList.some((user) => user.name === name)
          );
          const inactiveUsers = userAssignment.userAssignmentList.filter((user: AssignmentDTO) =>
            collaboratorsUserNames.includes(user.assignedUserName) && !user.isActive
          );
          // Combine both lists (inactive users and terminated users)
          const inactiveAndTerminatedUsers = [
            ...inactiveUsers,
            ...terminatedUsers.map((name: any) => ({ assignedUserName: name, isActive: false })) // Create inactive user objects for missing reviewers
          ];
          inactiveAndTerminatedUsers.forEach((user) => {
            const userAssignmentWithSource = { ...user, source: 'Change Control Collaborators' };
            inactiveObjects.push(userAssignmentWithSource);
          });
        }

        if (userAssignment.userType === UserType.CCReviewer) {
          // Extract the assignedUserNames from object.reviewers
          const reviewersUserNames = object.reviewers.map((user: any) => user.name);
          // Find users from reviewersUserNames that are not in userList
          const terminatedReviewers = reviewersUserNames.filter((reviewerName: any) =>
            !userList.some((user) => user.name === reviewerName)
          );
          // Filter the userAssignment.userAssignmentList to find users whose assignedUserName is in the list of reviewersUserNames
          const inactiveUsers = userAssignment.userAssignmentList.filter((user: AssignmentDTO) =>
            reviewersUserNames.includes(user.assignedUserName) && !user.isActive
        );
          // Combine both lists (inactive users and terminated reviewers)
          const inactiveAndTerminatedUsers = [
            ...inactiveUsers,
            ...terminatedReviewers.map((name: any) => ({ assignedUserName: name, isActive: false })) // Create inactive user objects for missing reviewers
          ];

          // Add each inactive user to inactiveObjects with the additional source property
          inactiveAndTerminatedUsers.forEach((user) => {
            const userAssignmentWithSource = { ...user, source: 'Change Control Reviewers' };
            inactiveObjects.push(userAssignmentWithSource);
          });
        }

        if (userAssignment.userType === UserType.CCApprover) {
          const approversUserNames = object.approvers.map((user: any) => user.name);
          const terminatedUsers = approversUserNames.filter((name: any) =>
            !userList.some((user) => user.name === name)
          );
          const inactiveUsers = userAssignment.userAssignmentList.filter((user: AssignmentDTO) =>
            approversUserNames.includes(user.assignedUserName) && !user.isActive
          );
          // Combine both lists (inactive users and terminated users)
          const inactiveAndTerminatedUsers = [
            ...inactiveUsers,
            ...terminatedUsers.map((name: any) => ({ assignedUserName: name, isActive: false })) // Create inactive user objects for missing reviewers
          ];
          inactiveAndTerminatedUsers.forEach((user) => {
            const userAssignmentWithSource = { ...user, source: 'Change Control Approvers' };
            inactiveObjects.push(userAssignmentWithSource);
          });
        }


        if (userAssignment.userType === UserType.CCVerifier) {
          // Extract the assignedUserNames from object.verifiers
          const verifiersUserNames = object.verifiers.map((user: any) => user.name);

          const terminatedUsers = verifiersUserNames.filter((name: any) =>
            !userList.some((user) => user.name === name)
          );

          // Filter the userAssignment.userAssignmentList to find users whose assignedUserName is in the list of verifiersUserNames
          const inactiveUsers = userAssignment.userAssignmentList.filter((user: AssignmentDTO) =>
            verifiersUserNames.includes(user.assignedUserName) && !user.isActive
          );
          // Combine both lists (inactive users and terminated users)
          const inactiveAndTerminatedUsers = [
            ...inactiveUsers,
            ...terminatedUsers.map((name: any) => ({ assignedUserName: name, isActive: false })) // Create inactive user objects for missing reviewers
          ];

          // Add each inactive user to inactiveObjects with the additional source property
          inactiveAndTerminatedUsers.forEach((user) => {
            const userAssignmentWithSource = { ...user, source: 'Change Control Verifier' };
            inactiveObjects.push(userAssignmentWithSource);
          });
        }

        if (userAssignment.userType === UserType.CCInternalClientContact) {
          if (object.internalClientContact != undefined || object.internalClientContact != null) {
            const internalClientContactUserName = object.internalClientContact.assignedUserName;
            // Check if the internalClientContactUserName is not present in userList
          let terminatedUser = null;
          if (!userList.find((user) => user.name === internalClientContactUserName)) {
            // Add internalClientContactUserName to terminatedUser if it's not found in userList
            terminatedUser = internalClientContactUserName;
          }
            const inactiveUsers = userAssignment.userAssignmentList.filter((user: AssignmentDTO) =>
              internalClientContactUserName.includes(user.assignedUserName) && !user.isActive
            );
            // Combine both lists (inactive users and terminated users)
          let inactiveAndTerminatedUsers = [];
          if (inactiveUsers && inactiveUsers.length > 0) {
            inactiveAndTerminatedUsers.push(...inactiveUsers);
          }
          else if (terminatedUser != null) {
            inactiveAndTerminatedUsers.push(terminatedUser);
          }

          inactiveAndTerminatedUsers.forEach((user) => {
              const userAssignmentWithSource = { ...user, source: 'Change Control Internal Client Contact' };
              inactiveObjects.push(userAssignmentWithSource);
            });
          }
        }

        if (userAssignment.userType === UserType.CCNotifiedUser) {
          if (object.notifiedUsers != undefined || object.notifiedUsers != null) {
            const usersNames = object.notifiedUsers.map((user: any) => user.assignedUserName);
            const terminatedUsers = usersNames.filter((name: any) =>
              !userList.some((user) => user.name === name)
            );
            const inactiveUsers = userAssignment.userAssignmentList.filter((user: AssignmentDTO) =>
              usersNames.includes(user.assignedUserName) && !user.isActive
            );
            // Combine both lists (inactive users and terminated users)
          const inactiveAndTerminatedUsers = [
            ...inactiveUsers,
            ...terminatedUsers.map((name: any) => ({ assignedUserName: name, isActive: false })) // Create inactive user objects for missing reviewers
          ];
          inactiveAndTerminatedUsers.forEach((user) => {
              const userAssignment = { ...user, source: 'Change Control Notified Users' };
              inactiveObjects.push(userAssignment);
            });
          }
        }

        if (userAssignment.userType === UserType.ACAssignees) {
          // Edge case check: where the assignee is disable, the object doesn't holds the value of assignee
          if (object.assignees != null && object.assignees != undefined) {
            const usersName = object.assignees;
            // Check if the usersName is not present in userList
          let terminatedUser = null;
          if (!userList.find((user) => user.name === usersName)) {
            // Add usersName to terminatedUser if it's not found in userList
            terminatedUser = usersName;
          }
            const inactiveUsers = userAssignment.userAssignmentList.filter((user: AssignmentDTO) =>
              usersName.includes(user.assignedUserName) && !user.isActive
            );

            // Combine both lists (inactive users and terminated users)
          let inactiveAndTerminatedUsers = [];
          if (inactiveUsers && inactiveUsers.length > 0) {
            inactiveAndTerminatedUsers.push(...inactiveUsers);
          }
          else if (terminatedUser != null) {
            inactiveAndTerminatedUsers.push(terminatedUser);
          }

          inactiveAndTerminatedUsers.forEach((user) => {
              const userAssignmentWithSource = { ...user, source: 'Action Item Assigned Users' };
              inactiveObjects.push(userAssignmentWithSource);
            });
          }
        }

        if (userAssignment.userType === UserType.ACVerifiers) {
          //check if this is not a mandatory field
          if (object.verifier != undefined || object.verifier != null) {
            const usersName = object.verifier;
             // Check if the usersName is not present in userList
          let terminatedUser = null;
          if (!userList.find((user) => user.name === usersName)) {
            // Add usersName to terminatedUser if it's not found in userList
            terminatedUser = usersName;
          }
            const inactiveUsers = userAssignment.userAssignmentList.filter((user: AssignmentDTO) =>
              usersName.includes(user.assignedUserName) && !user.isActive
            );
            // Combine both lists (inactive users and terminated users)
          let inactiveAndTerminatedUsers = [];
          if (inactiveUsers && inactiveUsers.length > 0) {
            inactiveAndTerminatedUsers.push(...inactiveUsers);
          }
          else if (terminatedUser != null) {
            inactiveAndTerminatedUsers.push(terminatedUser);
          }

          inactiveAndTerminatedUsers.forEach((user) => {
              const userAssignmentWithSource = { ...user, source: 'Action Item Verifier' };
              inactiveObjects.push(userAssignmentWithSource);
            });
          }
        }

        if (userAssignment.userType === UserType.InternalTrainers) {
          const usersName = object.map((obj: { assignedUserName: any; }) => obj.assignedUserName);
          const terminatedUsers = usersName.filter((name: any) =>
            !userList.some((user) => user.name === name)
          );
          const inactiveUsers = userAssignment.userAssignmentList.filter((user: AssignmentDTO) =>
            usersName.includes(user.assignedUserName) && !user.isActive
          );
          // Combine both lists (inactive users and terminated users)
          const inactiveAndTerminatedUsers = [
            ...inactiveUsers,
            ...terminatedUsers.map((name: any) => ({ assignedUserName: name, isActive: false })) // Create inactive user objects for missing reviewers
          ];
          inactiveAndTerminatedUsers.forEach((user) => {
            const userAssignment = { ...user, source: 'Internal Trainer' };
            inactiveObjects.push(userAssignment);
          });
        }

        if (userAssignment.userType === UserType.Owners) {
          const usersNames = object.owners.map((obj: { assignedUserName: any; }) => obj.assignedUserName);
          const terminatedUsers = usersNames.filter((name: any) =>
            !userList.some((user) => user.name === name)
          );
          const userListWithIsTerminatedTrue =  userAssignment.userAssignmentList.filter((user: AssignmentDTO) =>
            usersNames.includes(user.assignedUserName) && user.isTerminated
          );
          const inactiveUsers = userAssignment.userAssignmentList.filter((user: AssignmentDTO) =>
            usersNames.includes(user.assignedUserName) && !user.isActive
          );
          // Combine both lists (inactive users and terminated users)
          const inactiveAndTerminatedUsers = [
            ...inactiveUsers,
            ...terminatedUsers.map((name: any) => ({ assignedUserName: name, isActive: false })),
            ...userListWithIsTerminatedTrue.map((name:any)=>({assignedUserName: name, isActive: false})) // Create inactive user objects for missing reviewers
          ];
          inactiveAndTerminatedUsers.forEach((user) => {
            const userAssignment = { ...user, source: 'Owners' };
            inactiveObjects.push(userAssignment);
          });
        }

        if (userAssignment.userType === UserType.QualifiedTrainers) {
          const usersName = object.qualifiedTrainers.map((obj: { assignedUserName: any; }) => obj.assignedUserName);
          const terminatedUsers = usersName.filter((name: any) =>
            !userList.some((user) => user.name === name)
          );
          const inactiveUsers = userAssignment.userAssignmentList.filter((user: AssignmentDTO) =>
            usersName.includes(user.assignedUserName) && !user.isActive 
          );
          const userListWithIsTerminatedTrue =  userAssignment.userAssignmentList.filter((user: AssignmentDTO) =>
            usersName.includes(user.assignedUserName) && user.isTerminated
          );
          // Combine both lists (inactive users and terminated users)
          const inactiveAndTerminatedUsers = [
            ...inactiveUsers,
            ...terminatedUsers.map((name: any) => ({ assignedUserName: name, isActive: false })),
            ...userListWithIsTerminatedTrue.map((name:any)=>({assignedUserName: name, isActive: false}))
          ];
          inactiveAndTerminatedUsers.forEach((user) => {
            const userAssignment = { ...user, source: 'Qualified Trainers' };
            inactiveObjects.push(userAssignment);
          });
        }

      });
    }
    return inactiveObjects.length > 0 ? inactiveObjects : undefined;
  }


   getDistinctSources(assignments: any[]): string {
    const sources = new Set<string>();
    assignments.forEach((assignment) => {
      if (assignment.source) {
        sources.add(assignment.source);
      }
    });
    return [...sources].join(", ");
  }

  
  // Below Method is used to create one more property as Assigned Admin/ Assigned User etc.., of Type string which is used to sort and filter data in PanelList
  getPanelListDataWithProperty(data: any, propertyName: string): any {
    const panelListData = data?.map((item: any) => {
      const propertyValue = item[propertyName];
      const assignedAdminList: string[] = [];
  
      if (Array.isArray(propertyValue)) {
        propertyValue.forEach((obj: any) => {
          if (obj && obj.name) {
            assignedAdminList.push(obj.name);
          }
          else if(obj && obj.assignedUserName){ // assignedUserName is added to handle the data from assignment group Panel List
            assignedAdminList.push(obj.assignedUserName);
          }
        });
      } else if (typeof propertyValue === 'object' && propertyValue !== null && propertyValue.assignedUserName) {
        assignedAdminList.push(propertyValue.assignedUserName);
      } else if (propertyValue !== null) {
        assignedAdminList.push(String(propertyValue));
      }
  
      return {
        ...item,
        [`${propertyName}List`]: assignedAdminList,
      };
    });
  
    return panelListData;
  }  

  // This mehod is for Updating Assignment Type Array For User - Course Mapping for Save
  updateUserToAssignmentTypeArrayForCourse(userList: string[] , users: string[] | null, assignmentGroupList: any,  assignedAssignmentGroupsAndUsersList: any): AssignmentDTO[] | undefined {
    const assignmentDTOs: AssignmentDTO[] = [];
    if (!users) {
      return undefined;
    }
    users.forEach((user) => {
    // If selected user is direct assigned User
    if (userList.some((obj:any) => obj.value === user)) {
        assignmentDTOs.push({
          assignmentType: 1,
          assignedUserName: user,
          assignmentId: undefined,
          isActive: false
        });
      } else {
        // If Selection is an Assigment Group
        let assignmentGroup = this.getAssignmentGroup(assignmentGroupList.filter((obj:any) => obj.name === user));
        // if assignmentGroup is undefined, the assignment group is not available in list fetched - here Active AGs
        if(typeof assignmentGroup === 'undefined') {
          const filteredItems = assignedAssignmentGroupsAndUsersList.flat().filter((obj: any) => obj.assignedUserName === user);

          // Pass the filtered items to getAssignmentGroup method
          const assignmentGroup = this.getAssignmentGroup(filteredItems);

          assignmentDTOs.push({
            assignmentType: 0,
            assignedUserName: user,
            assignmentId: assignmentGroup?.assignmentId,
            isActive : assignmentGroup?.isActive
          });
        }
        else{
          assignmentDTOs.push({
            assignmentType: 0,
            assignedUserName: user,
            assignmentId: assignmentGroup?.id,
            isActive : assignmentGroup?.isActive
          });
        }
      }
    });    
    return assignmentDTOs;
  }

  //Add inactive users to userlist to display them in the dropdowns
  addInactiveUsersToUserList(inactiveUsers: any[], usersList: any[]): any[] {
    inactiveUsers.forEach(user => {
      if (!usersList.some(existingUser => existingUser.value === user)) {
        usersList.unshift({ value: user, name: user });
      }
    });
    return usersList;
  }


   // Get inactive users from the list of qualified trainers
   getInactiveUsers(dropdownUserList: any[], userList: any[]): any[] {
    return dropdownUserList.filter(trainer => !userList.includes(trainer));
  }

  updateUserToAssignmentTypeForHC(userList: string[], user: string | null, assignmentGroupList: any, assignedAssignmentGroupsAndUsersList: any): AssignmentDTO | undefined {
    if (!user) {
      return undefined;
    }
    this.foundUser = userList.find((obj:any) => obj.value === user);  
    if (this.foundUser!=null && this.foundUser!=undefined && (this.foundUser?.id === null || this.foundUser?.id === undefined)) {
      return {
        assignmentType: 1,
        assignedUserName: user,
        assignmentId: undefined,
        isActive: false
      };
    } else {
      let assignmentGroup = this.getAssignmentGroup(assignmentGroupList.filter((obj:any) => obj.name === user));
      if(typeof assignmentGroup === 'undefined') {
        assignmentGroup = this.getAssignmentGroup(assignedAssignmentGroupsAndUsersList.filter((obj:any) => obj.name === user))
      }
      return {
        assignmentType: 0,
        assignedUserName: user,
        assignmentId: assignmentGroup?.id,
        isActive : assignmentGroup?.isActive
      };
    }
  }  
}
